export default {"src":"/_next/static/media/promotions.bd9a673e.svg","height":46,"width":52,"blurWidth":0,"blurHeight":0};